/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Navbar } from "react-bootstrap";

// links that appear in navbar - they are separated from this component (navbar) so that we can redner them on responsive in sidebar as well

import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import LogOutIcon from "views/Forms/LogoutIcon/logoutIcon.jsx";

// we import here the routes for dashboard pages (links that appear in sidebar) to set navbar's name

import routes from "routes.js";

class AdminNavbar extends Component {
  breadcrumbPath = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.breadcrumbPath(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf("/edit_medication_category") !== -1) {
          return "medication-category";
        } else if (window.location.href.indexOf("/order/") !== -1) {
          return "/admin/order_list";
        } else if (window.location.href.indexOf("/replicate-order/") !== -1) {
          return "/admin/order_list";
        } else if (
          window.location.href.indexOf("/subscriptionpackage") !== -1
        ) {
          return "/admin/subscriptionpackage";
        } else if (
          window.location.href.indexOf("/addmedicationpackages") !== -1
        ) {
          return "/admin/medicationpackages";
        } else if (window.location.href.indexOf("/editPo/") !== -1) {
          return "/admin/poList";
        } else if (
          window.location.href.indexOf(
            "/edit-warehouse-inventory-dispatch/",
          ) !== -1
        ) {
          return "/admin/Warehouse Inventory Dispatch";
        }
        // else if (window.location.href.indexOf( '/addsubscriptionpackage') !== -1)
        // {
        //    return "/admin/addsubscriptionpackage";
        // }
        else {
          if (
            window.location.href.indexOf(routes[i].layout + routes[i].path) !==
            -1
          ) {
            return routes[i].breadcrumbPath;
          }
        }
      }
    }
    return activeRoute;
  };
  breadcrumb = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.breadcrumb(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf("/edit_medication_category") !== -1) {
          return "Medication Category";
        } else if (window.location.href.indexOf("/order/") !== -1) {
          return "All Orders";
        } else if (window.location.href.indexOf("/order-new/") !== -1) {
          return "All Orders";
        } else if (window.location.href.indexOf("/replicate-order/") !== -1) {
          return "All Orders";
        } else if (window.location.href.indexOf("/laborder/") !== -1) {
          return "Lab OrderList";
        } else if (
          window.location.href.indexOf("/addmedicationpackages") !== -1
        ) {
          return "Medication Package";
        } else if (
          window.location.href.indexOf("/addsubscriptionpackage") !== -1
        ) {
          return "Subscription Products";
        } else if (window.location.href.indexOf("/editPo/") !== -1) {
          return "All PO";
        } else if (window.location.href.indexOf("/credit_note/") !== -1) {
          return "Edit Order";
        } else if (window.location.href.indexOf("/claim_report/") !== -1) {
          return "Claim Report";
        } else if (
          window.location.href.indexOf(
            "/edit-warehouse-inventory-dispatch/",
          ) !== -1
        ) {
          return "Warehouse Inventory Dispatch";
        } else if (window.location.href.indexOf("/edit-pickUp/") !== -1) {
          return "All Orders";
        } else {
          if (
            window.location.href.indexOf(routes[i].layout + routes[i].path) !==
            -1
          ) {
            return routes[i].breadcrumb;
          }
        }
      }
    }
    return activeRoute;
  };
  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf("/medication-category") !== -1) {
          return "Medication Category";
        } else if (window.location.href.indexOf("/medicationTags") !== -1) {
          return "Medication Tags";
        } else if (
          window.location.href.indexOf("/edit_medicationTags") !== -1
        ) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit Medication Tag";
        } else if (window.location.href.indexOf("/order/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit Order - #" + num;
        } else if (window.location.href.indexOf("/order-new/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit Order - #" + num;
        } else if (window.location.href.indexOf("/replicate-order/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Replicate Order - #" + num;
        } else if (window.location.href.indexOf("/laborder/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit Lab Order - #" + num;
        } else if (
          window.location.href.indexOf("/productcatalogue_activity") !== -1
        ) {
          return "Catalogue Package Activities";
        } else if (window.location.href.indexOf("/medicationpackages") !== -1) {
          return "Medication Packages";
        } else if (
          window.location.href.indexOf("/addmedicationpackages") !== -1
        ) {
          return "Add Medication Package";
        } else if (window.location.href.indexOf("/medicationTags") !== -1) {
          return "Medication Tags";
        } else if (window.location.href.indexOf("/subscriptionorder/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit subscription Order - #" + num;
        } else if (
          window.location.href.indexOf("/subscriptionpackage") !== -1
        ) {
          return "Subscription Products";
        } else if (
          window.location.href.indexOf("/addsubscriptionpackage") !== -1
        ) {
          return "Add Subscription Products";
        } else if (window.location.href.indexOf("/editPo/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit PO - #" + num;
        } else if (window.location.href.indexOf("/credit_note/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Credit Note - #" + num;
        } else if (window.location.href.indexOf("/claim_report") !== -1) {
          return "Claim Report";
        } else if (
          window.location.href.indexOf(
            "/edit-warehouse-inventory-dispatch/",
          ) !== -1
        ) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit Warehouse Inventory Dispatch - #" + num;
        } else if (window.location.href.indexOf("/edit-pickUp/") !== -1) {
          var num = window.location.href.substring(
            window.location.href.lastIndexOf("/") + 1,
          );
          return "Edit PickUp Order - #" + num;
        } else {
          if (
            window.location.href.indexOf(routes[i].layout + routes[i].path) !==
            -1
          ) {
            return routes[i].name;
          }
        }
      }
    }
    return activeRoute;
  };
  // function for responsive that hides/shows the sidebar
  mobileSidebarToggle = (e) => {
    document.documentElement.classList.toggle("nav-open");
  };
  render() {
    return (
      <Navbar fluid className={this.props.navbar ? "navbar-fixed" : ""}>
        <div className="navbar-minimize">
          <button
            id="minimizeSidebar"
            className="btn btn-default btn-fill btn-round btn-icon"
            onClick={this.props.handleMiniClick}
          >
            <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
            <i className="fa fa-navicon visible-on-sidebar-mini" />
          </button>
        </div>
        <Navbar.Header>
          {this.breadcrumb(routes) == "" || this.breadcrumb(routes) == null ? (
            ""
          ) : (
            <React.Fragment>
              <Navbar.Brand>
                {/* Here we create navbar brand, based on route name */}

                <a href={this.breadcrumbPath(routes)}>
                  {this.breadcrumb(routes)}{" "}
                </a>
              </Navbar.Brand>
              <Navbar.Brand>
                {this.breadcrumb(routes) == "" ||
                this.breadcrumb(routes) == null
                  ? ""
                  : ">"}
              </Navbar.Brand>
            </React.Fragment>
          )}
          <Navbar.Brand>
            {/* Here we create navbar brand, based on route name */}
            <a href="#pablo">{this.getActiveRoute(routes)}</a>
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>

        {/* Here we import the links that appear in navbar */}
        {window.innerWidth > 992 ? (
          <Navbar.Collapse>
            <AdminNavbarLinks />
            <LogOutIcon />
          </Navbar.Collapse>
        ) : null}
      </Navbar>
    );
  }
}

export default AdminNavbar;
